    import React, { useState, useEffect } from "react";
    import styled from "styled-components";
    import Sidebar from "../Sidebar";
    import { FaFileInvoice, FaEdit } from "react-icons/fa";
    import axios from "axios";
import TopBar from "../TopBar";

    const DashboardWrapper = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden;
    `;

    const Content = styled.div`
    flex: 1;
    padding: 20px;
    background-color: #f5f5f5;
    overflow-y: auto;
    `;

    
const PageBody = styled.div`
  flex: 1;
  overflow: auto;
  padding: 20px;     /* or 30px to match other pages */
  background-color: #f5f5f5;
`;

    const FormWrapper = styled.div`
    width: 100%;
    padding: 30px 40px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 8px;
    box-sizing: border-box;
    `;

    const Title = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    font-size: 1.2rem;
    font-weight: bold;
    color: #87CEEB;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    `;

    const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
    `;

    const NipGroup = styled.div`
    display: flex;
    flex-direction: column;
    grid-column: span 2;

    @media (max-width: 768px) {
        grid-column: span 1;
    }
    `;

    const NipRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
    `;

    const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    `;

    const Label = styled.label`
    font-weight: bold;
    margin-bottom: 5px;
    `;

    const Input = styled.input`
    width: 100%;                // 👈 ensures input fills the container
    padding: 14px 16px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 16px;
    background-color: ${({ readOnly }) => (readOnly ? "#f0f0f0" : "white")};
    color: ${({ readOnly }) => (readOnly ? "#666" : "#000")};
    cursor: ${({ readOnly }) => (readOnly ? "not-allowed" : "text")};
    transition: background-color 0.2s ease, color 0.2s ease;
    min-height: 48px;
  `;
  
  
  
    const CheckButton = styled.button`
    height: 42px;
    padding: 0 18px;
    font-size: 14px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #0056b3;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
    `;

    const NipMessage = styled.div`
    margin-top: 8px;
    font-size: 14px;
    color: ${({ type }) => (type === "error" ? "#d9534f" : "#28a745")};
    font-weight: 500;
    `;

    const email = JSON.parse(localStorage.getItem("user"))?.Email;

    const InvoiceSettings = () => {
        const [data, setData] = useState({
            nip: "",
            nazwa: "",
            wojewodztwo: "",
            powiat: "",
            gmina: "",
            miejscowosc: "",
            kodPocztowy: "",
            ulica: "",
            nrNieruchomosci: "",
            nrLokalu: "",
            email: email || "",
          });
          
    
      const [nipMessage, setNipMessage] = useState({ type: "", text: "" });
      const [saveMessage, setSaveMessage] = useState({ text: "", type: "" });
      const [saving, setSaving] = useState(false);
      const [isEditable, setIsEditable] = useState(false);
   
      const skipFields = ["_id", "__v", "nip", "email"];
      const [showGusButton, setShowGusButton] = useState(false);


    
      useEffect(() => {
        if (email) {
          axios
            .get(`https://server229256.nazwa.pl/api/invoice/${email}`)
            .then((res) => {
              setData(res.data);
              setIsEditable(false);
            })
            .catch(() => {});
        }
      }, [email]);
    
      const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      };
    
      const handleSave = async () => {
        try {
          setSaving(true);
          const { _id, __v, ...safeData } = data; // REMOVE these two fields
      
          await axios.post("https://server229256.nazwa.pl/api/invoice", {
            email,
            ...safeData,
          });
      
          setSaveMessage({ text: "✅ Dane zapisane poprawnie.", type: "success" });
          setIsEditable(false);
        } catch (err) {
          console.error(err);
          setSaveMessage({ text: "❌ Błąd zapisu danych.", type: "error" });
        } finally {
          setSaving(false);
          setTimeout(() => setSaveMessage({ text: "", type: "" }), 5000);
        }
      };
      
    
      const handleCheckNip = async () => {
        const nip = data.nip.trim();
        if (nip.length !== 10 || isNaN(nip)) return;
      
        try {
          const res = await axios.get(`https://server229256.nazwa.pl/api/klienci/${nip}`);
          const klient = res.data;
      
          if (klient && typeof klient === "object" && Object.keys(klient).length > 0) {
            setData((prev) => ({ ...prev, ...klient }));
            setNipMessage({
              type: "success",
              text: "✅ Dane firmy zostały uzupełnione automatycznie z bazy lokalnej.",
            });
            setShowGusButton(false);
          } else {
            // Not found in local DB
            setNipMessage({
              type: "error",
              text: "❌ Nie znaleziono firmy w bazie lokalnej.",
            });
            setShowGusButton(true); // Show button for GUS
          }
        } catch (err) {
          console.error("Błąd sprawdzania NIP:", err.message);
          setNipMessage({
            type: "error",
            text: "❌ Wystąpił błąd podczas sprawdzania bazy lokalnej.",
          });
          setShowGusButton(true);
        }
      };

      
     const handleCheckNipGus = async () => {
  // keep only digits, max 10
  const nip = data.nip.replace(/\D/g, "").slice(0, 10);
  if (nip.length !== 10) return;

  try {
    const res = await axios.get(
      `https://server229256.nazwa.pl/api/search?nip=${nip}`
    );
    const { result: gusResult } = res.data || {};

    if (!gusResult) {
      setNipMessage({
        type: "error",
        text: "❌ Nie udało się znaleźć firmy w bazie GUS.",
      });
      return;
    }

    // be robust to shape: sometimes backend may return plain object, sometimes { basic, full }
    const basic = gusResult.basic || gusResult || {};
    const full = gusResult.full || {};

    const sanitize = (value) =>
      Array.isArray(value) ? value[0] : value || "";

    // NAME: basic → fiz_ → praw_
    const nazwa =
      sanitize(basic.Nazwa) ||
      sanitize(full.fiz_nazwa) ||
      sanitize(full.praw_nazwa) ||
      "";

    // ADDRESS: prefer CEIDG (fiz_), then legal (praw_), then basic GUS fields
    const wojewodztwo =
      sanitize(full.fiz_adSiedzWojewodztwo_Nazwa) ||
      sanitize(full.praw_adSiedzWojewodztwo_Nazwa) ||
      sanitize(basic.Wojewodztwo);

    const powiat =
      sanitize(full.fiz_adSiedzPowiat_Nazwa) ||
      sanitize(full.praw_adSiedzPowiat_Nazwa) ||
      sanitize(basic.Powiat);

    const gmina =
      sanitize(full.fiz_adSiedzGmina_Nazwa) ||
      sanitize(full.praw_adSiedzGmina_Nazwa) ||
      sanitize(basic.Gmina);

    const miejscowosc =
      sanitize(full.fiz_adSiedzMiejscowosc_Nazwa) ||
      sanitize(full.praw_adSiedzMiejscowosc_Nazwa) ||
      sanitize(basic.Miejscowosc);

    const kodPocztowy =
      sanitize(full.fiz_adSiedzKodPocztowy) ||
      sanitize(full.praw_adSiedzKodPocztowy) ||
      sanitize(basic.KodPocztowy);

    const ulica =
      sanitize(full.fiz_adSiedzUlica_Nazwa) ||
      sanitize(full.praw_adSiedzUlica_Nazwa) ||
      sanitize(basic.Ulica);

    const nrNieruchomosci =
      sanitize(full.fiz_adSiedzNumerNieruchomosci) ||
      sanitize(full.praw_adSiedzNumerNieruchomosci) ||
      sanitize(basic.NrNieruchomosci);

    const nrLokalu =
      sanitize(full.fiz_adSiedzNumerLokalu) ||
      sanitize(full.praw_adSiedzNumerLokalu) ||
      sanitize(basic.NrLokalu);

    const gusData = {
      nip,
      nazwa,
      wojewodztwo,
      powiat,
      gmina,
      miejscowosc,
      kodPocztowy,
      ulica,
      nrNieruchomosci,
      nrLokalu,
      email,
    };

    setData((prev) => ({ ...prev, ...gusData }));
    setNipMessage({
      type: "success",
      text: "✅ Dane zostały uzupełnione z GUS (REGON).",
    });
    setIsEditable(true);
    setShowGusButton(false);
  } catch (err) {
    console.error("Błąd pobierania z GUS:", err.message);
    setNipMessage({
      type: "error",
      text: "❌ Błąd połączenia z API GUS.",
    });
  }
};

      
      
      
    
      const formatLabel = (str) =>
        str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());
    
      const optionalFields = ["nrNieruchomosci", "nrLokalu"];
      const isFormComplete = Object.entries(data).every(
        ([key, val]) => skipFields.includes(key) || optionalFields.includes(key) || val !== ""
      );
      
    
return (
  <DashboardWrapper>
    <Sidebar />

    <Content>
      <TopBar />

      <PageBody>
        <Title>
          <FaFileInvoice />
          Ustawienia i Dane / Dane do Faktury
        </Title>

        <FormWrapper>
          {saveMessage.text && (
            <div
              style={{
                marginBottom: "15px",
                padding: "10px 15px",
                borderRadius: "6px",
                fontWeight: "bold",
                color: saveMessage.type === "success" ? "#155724" : "#721c24",
                backgroundColor: saveMessage.type === "success" ? "#d4edda" : "#f8d7da",
                border: `1px solid ${
                  saveMessage.type === "success" ? "#c3e6cb" : "#f5c6cb"
                }`,
              }}
            >
              {saveMessage.text}
            </div>
          )}

          {isEditable && !isFormComplete && (
            <div
              style={{
                marginBottom: "15px",
                padding: "10px 15px",
                borderRadius: "6px",
                fontWeight: "bold",
                color: "#856404",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
              }}
            >
              ⚠️ Uzupełnij wszystkie wymagane pola przed zapisaniem danych.
            </div>
          )}

          <FormGrid style={{ gridTemplateColumns: "1fr 1fr" }}>
            <NipGroup>
              <Label htmlFor="nip">NIP</Label>
              <NipRow>
                <Input
                  id="nip"
                  name="nip"
                  value={data.nip}
                  onChange={(e) => {
                    setData({ ...data, nip: e.target.value });
                    setNipMessage({ type: "", text: "" });
                    setShowGusButton(false);
                  }}
                  placeholder="Wpisz NIP (10 cyfr)"
                  readOnly={!isEditable}
                />
                {data.nip.length === 10 && !isNaN(data.nip) && (
                  <CheckButton onClick={handleCheckNip}>🔍 Sprawdź</CheckButton>
                )}
              </NipRow>

              {nipMessage.text && <NipMessage type={nipMessage.type}>{nipMessage.text}</NipMessage>}

              {showGusButton && (
                <CheckButton
                  style={{ marginTop: "10px", width: "fit-content" }}
                  onClick={handleCheckNipGus}
                >
                  🏛️ Spróbuj pobrać dane z GUS
                </CheckButton>
              )}
            </NipGroup>

            {Object.entries(data).map(([key, value]) => {
              if (skipFields.includes(key)) return null;
              return (
                <InputGroup key={key}>
                  <Label htmlFor={key}>{formatLabel(key)}</Label>
                  <Input
                    id={key}
                    name={key}
                    value={value}
                    onChange={handleChange}
                    placeholder={`Wpisz ${formatLabel(key)}`}
                    readOnly={!isEditable}
                  />
                </InputGroup>
              );
            })}

            {isEditable && isFormComplete && (
              <CheckButton disabled={saving} style={{ gridColumn: "span 2" }} onClick={handleSave}>
                💾 {saving ? "..." : "Zapis Dane"}
              </CheckButton>
            )}

            {!isEditable && (
              <CheckButton style={{ gridColumn: "span 2" }} onClick={() => setIsEditable(true)}>
                <FaEdit style={{ marginRight: 5 }} />
                Edytuj
              </CheckButton>
            )}
          </FormGrid>
        </FormWrapper>
      </PageBody>
    </Content>
  </DashboardWrapper>
);

      
    };
    
    export default InvoiceSettings;
    
